import axios from "axios";

const API_BASE_URL = "https://m.dev-ped.com";

export const redeemSevenKnightCoupon = async (payload) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/seven-knight/redeem-coupon`,
      payload
    );
    return res.data;
  } catch (error) {
    console.error("Error redeemSevenKnightCoupon:", error);
    throw error;
  }
};

export const checkHealth = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/health`);
    return res.data;
  } catch (error) {
    console.error("Error checkHealth:", error);
    throw error;
  }
};
